import { useEffect, useRef } from "react"
import { loadYouTubeIframe } from "./loadYouTubeIframe"

export type YouTubeIframeProps = {
  videoId: string
  autoPlay?: boolean
  mute?: boolean
  loop?: boolean
  enablejsapi?: boolean
}

export const YouTubeIframe = ({ videoId, autoPlay, mute, loop, enablejsapi }: YouTubeIframeProps) => {
  const iframeParent = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (iframeParent.current && !iframeParent.current.firstChild) {
      loadYouTubeIframe({ iframeParent: iframeParent.current, videoId, autoPlay, mute, loop, enablejsapi })
    }
  }, [videoId, autoPlay, mute, loop, enablejsapi])

  return <div ref={iframeParent} className="size-full" />
}
